import axios from 'axios'


//const baseURL='http://122.165.55.214/BMS_ERP_API/api/'
// const baseURL='http://localhost:5241/api/'
// Demo
const baseURL='http://targetdemo.asktek.net/erp.webmis.demo.webapi/api/'
const instance=axios.create({
    baseURL
})

export default {
    baseURL,
    instance
} 